// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5cfe7ea9","455":"a1d70115"}[chunkId] + ".chunk.js";
};